<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
export default {
    data() {
        return {
            tableData: [],
            currentPage: 1,
            pageSize: 50,
            total: 0,
            sortField: '',
            sortRule: '',
            filterDrawer: false,
            filter: {
                status: '',
                id: ''
            },
            tabData: [],
        };
    },
    methods: {
        init() {
            this.getPrizeList()
        },
        async getData() {
            let data = await this.api.pointsystemTaskType({
                access_token: localStorage.getItem("access_token"),
            });
            this.tabData = data.data;
        },
        async getPrizeList() {
            let { status, id } = this.filter
            let params = {
                access_token: localStorage.getItem("access_token"),
                page: this.currentPage,
                limit: this.pageSize,
                status,
                id
            }
            //任务管理列表api

            let data = await this.api.pointsystemList(params)
            if(data) {
                this.tableData = data.data
                this.total = data.total
            }
        },
        sizeChange(pageSize) {
            this.pageSize = pageSize;
            this.currentPage = 1
            this.getPrizeList()
        },
        currentChange(currentPage) {
            this.currentPage = currentPage
            this.getPrizeList()
            this.tableScrollTop()
        },
        // 新增、查看、编辑
        goNewPrize(type, params = {}) {
            if(type == 'task'){
                this.$router.push({ path: `task-detail/${type}`, query: Object.assign(params, { pageType: type })})
            }else{
                this.$router.push({ path: `new-task/${type}`, query: Object.assign(params, { pageType: type })})
            }
            
        },
        async prizeShelve(item) {
            await this.api.pointsystemShelve({
                access_token: localStorage.getItem("access_token"),
                id: item.id,
                status: item.status == 1 ? -1 : 1
            })
            this.$message({ message: `${item.status == 1 ? '已下架' : '已上架'}`, type: 'success' })
            this.getPrizeList();
        },
        closeFilterDrawer() {
            this.filterDrawer = false
        },
        async searchClick() {
            this.currentPage = 1

            await this.getPrizeList()
            this.filterDrawer = false
        },
        clearFilter() {
            this.filter = { status: '', id: '' }
        }
    },
    created() {
        this.init();
        this.getData();
    },
};
</script>
